import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { pendings } from './data/pending-data';
import { trainingApi } from '../../services';
import { Util } from '../../services';
import { utitService } from '../../services/util';
import TrfDetailsView from './trf-details-view';
import EmpTrfDetailsView from './emp-trf-details-view';
import { Dialog } from 'primereact/dialog';
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from "primereact/calendar";
import { Editor } from 'primereact/editor';
import { useFormik } from 'formik';
import TeamTrainingUserDetailsView from './team-training-user-details-view';
import { typeOfTraining } from "../../common/util/constants";
import EditEmpTrfForm from './update-emp-trf-from';
import { AutoComplete } from "primereact/autocomplete";
import { skillService } from "../../services/profile";

const AdminTrfListing = () => {
    const [history, setHistory] = useState([]);
    const [isNewTrf, setNewTrf] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isTrfDetailVisible, setIsTrfDetailVisible] = useState(false);
    const [tab, setTab] = useState('Approvals');
    const [editedTRFData, setEditedTRFData] = useState([]);
    const [approvals, setApprovals] = useState([]);
    const [onJobTrf, setOnJobTrf] = useState([]);
    const [feedbacks, setFeedbacks] = useState([]);
    const [feedbackBadgeCount, setFeedbackBadgeCount] = useState();
    const [onJobBadgeCount, setOnJobBadgeCount] = useState();
    const [appovalDialog, setAppovalDialog] = useState(false);
    const [updateAssesmentDialog, setUpdateAssesmentDialog] = useState(false);
    const [rejectDialog, setRejectDialog] = useState(false);
    const [feedbackDialog, setFeedbackDialog] = useState(false);
    const [activeTRF, setActiveTRF] = useState({});
    const [startDate, setStartDate] = useState(null);
    const [feedback, setFeedback] = useState("");
    const [endDate, setEndDate] = useState(null);
    const [nominatedParticipant, setNominatedParticipant] = useState();
    const [effectivenessSummary, setEffectivenessSummary] = useState([]);
    const [empTrfDetailId, setEmpTrfDetailId] = useState('');
    const [trainingType, setTrainingType] = useState(null);
    const [targetSkill, setTargetSkill] = useState(null);
    const [summary, setSummary] = useState(null);
    const [finalReport, setFinalReport] = useState(null);
    const [tRFTrainingId, setTRFTrainingId] = useState('');
    const [assesmentLink, setAssesmentLink] = useState('');
    const [feedbackLink, setFeedbackLink] = useState('');
    const [assesmentStatus, setAssesmentStatus] = useState('No');
    const [enableAssesmentStatus, setEnableAssesmentStatus] = useState(true);
    const [activeRecord, setActiveRecord] = useState({});
    const [empDetailDialog, setEmpDetailDialog] = useState(false);
    const [outcomeAchievedStatus, setOutcomeAchievedStatus] = useState();
    const [managerFeedbackComment, setManagerFeedbackComment] = useState();
    const [skillRatingByManager, setSkillRatingByManager] = useState();

    const [feedbackApprovalStatus, setFeedbackApprovalStatus] = useState(true);
    const [feedbackRejectedStatus, setFeedbackRejectedStatus] = useState(true);
    const [isValid, setIsValid] = useState(false);

    const [editTrfDialog, setEditTrfDialog] = useState(false);
    const [editTrfDetails, setEditTrfDetails] = useState({});
    const [selectedTrfForApproval, setSelectedTrfForApproval] = useState([]);
    const [selectedTrfForFedback, setSelectedTrfForFedback] = useState([]);

    const [filteredTrainingCategory, setFilteredTrainingCategory] = useState(null);
    const [filterSkill, setFilterSkill] = useState(null);
    const [trainingCategory, setTrainingCategory] = useState([]);
    const [filteredSkill, setFilteredSkill] = useState(null);
    const [skillList, setSkillList] = useState([]);
    const [selectedFeedbackType, setSelectedFeedbackType] = useState(0);

    useEffect(() => {
        getHistory();
        getOnJobTrfHistory();
        fetchCategories();
        fetchSkillsList();
    }, []);

    const fetchSkillsList = () => {
        skillService.getSkills().then((resp) => {
            setSkillList(resp.data.data);
        });
    };

    const fetchCategories = () => {
        trainingApi.fetchTrainingCategoryList().then((resp) => {
            setTrainingCategory(resp.data.data);
        });
    };

    const searchSkill = (event) => {
        setTimeout(() => {
            let _filteredSkill;
            if (!event.query.trim().length) {
                _filteredSkill = [...skillList];
            } else {
                _filteredSkill = skillList.filter((p) => {
                    if (p.title !== null) {
                        return p.title.toLowerCase().startsWith(event.query.toLowerCase());
                    }
                });
            }
            setFilteredSkill(_filteredSkill);
        }, 250);
    };

    const getOnJobTrfHistory = () => {
        trainingApi.fetchonJobTrainings().then(resp => {
            setOnJobTrf(resp.data?.data);
            const activeOnJobBadge = resp.data?.data.filter((el) => {
                return !el?.isTMFeedback;
            });
            setOnJobBadgeCount(activeOnJobBadge.length);
        }).catch(e => {
        });
    };

    const getHistory = () => {
        trainingApi.getTrfHistory().then(resp => {
            const data = resp.data?.data;


            console.log(resp.data?.data, "<<<>>>>")
            setHistory(sortByRequesterName(data));

            const pendings = data.filter(x => x.status === 4 || x.status === 2);
            setApprovals(sortByRequesterName(pendings));

            // const feedbacks = data.filter(x => x.status !== 4 || x.status !== 2);
            
            // const feedbacks = data.filter(x => x.status === 5);
            // setFeedbacks(sortByRequesterName(feedbacks));

            const feedbacks = data.filter(item =>
                item.status === 5 &&
                item.trainingDetails.some(detail =>
                    detail.trainingDetailStatus === 2 &&
                    // ✅ Exclude the "Completed" logic
                    !(
                        (detail.trainingType === 'Instructor-Led' &&
                            detail.is_assessment === true &&
                            detail.is_feedback === true &&
                            detail.is_assesment_completed === true &&
                            detail.is_feedback_completed === true
                        ) ||
                        (detail.trainingType === 'Self-Paced' &&
                            detail.is_assessment === false &&
                            detail.is_feedback === true &&
                            detail.is_feedback_completed === true
                        )
                    )
                )
            );
            setFeedbacks(sortByRequesterName(feedbacks));

            const activeFeedbackBadge = feedbacks.filter((el) => {
                return !el?.trainingDetails[0]?.isTMFeedback;
            });
            setFeedbackBadgeCount(activeFeedbackBadge.length);

        }).catch(e => {
        });
    };

    const sortByRequesterName = (data) => {
        return data?.sort((a, b) => a.nameOfRequester.localeCompare(b.nameOfRequester));
    };

    const actionTrfDetailsBody = (r) => {
        return (<>
            <Button icon="pi pi-eye" className="p-button-rounded p-button-text" severity="secondary" tooltip='View TRF Details' onClick={() => viewTrfDetailDialog(r)} tooltipOptions={{ position: 'top' }} />
            <Button icon="pi pi-check" className="p-button-rounded p-button-text" tooltip='Update' onClick={() => onJobUpdateAssesmentForm(r)}
                // disabled={r?.is_assesment_completed && r?.is_feedback_completed ? true : false} 
                disabled={r?.trainingType === 'Self-Paced' && r?.trainingDetailStatus === 2 && !r?.is_assessment && !r?.is_feedback ? false : true} />

            {/* <Button icon="pi pi-check-circle" className="p-button-rounded p-button-text" severity="success" tooltip='Feedback' onClick={() => onJobFeedbackForm(r)} tooltipOptions={{ position: 'top' }} disabled={r?.is_assesment_completed && r?.is_feedback_completed && r?.isManagerValidate && r?.isManagerFeedback && !r?.isTMFeedback ? false : true} /> */}
            <Button icon="pi pi-check-circle" className="p-button-rounded p-button-text" severity="success" tooltip='Feedback' onClick={() => onJobFeedbackForm(r)} tooltipOptions={{ position: 'top' }} disabled={(r?.trainingType === 'Self-Paced' && !r?.is_assesment_completed && r?.is_feedback_completed && r?.isManagerValidate && r?.isManagerFeedback && !r?.isTMFeedback) ? false : true} />
        </>)
    }

    const editTrfDetailsForm = (rowData) => {
        setEditTrfDetails(rowData);
        setEditTrfDialog(true);
    }

    const reload = () => {
        setSelectedTrfForApproval([]);
        setEditTrfDialog(false);
        setAppovalDialog(false);
        getHistory();
        getOnJobTrfHistory();
    }

    const editTrfDetailsDialog = () => {
        return (<>
            <Dialog header="TRF Approvals" visible={editTrfDialog} className='full_dialog' onHide={() => { setEditTrfDialog(false); setIsValid(false); setFeedback(''); }}>
                <EditEmpTrfForm reload={reload} userTrfDetail={editTrfDetails} type={0} viewType={true}/>
            </Dialog>
        </>)
    }

    const actionBody = (r, o = 'approvals') => {
        return (<>
            {['history', 'feedback'].includes(o) && <>
                <Button icon="pi pi-eye" className="p-button-rounded p-button-text" severity="secondary" tooltip='View TRF' onClick={() => viewDialog(r)} tooltipOptions={{ position: 'top' }} />
            </>}
            {o === 'approvals' && <>
                <Button icon="pi pi-eye" className="p-button-rounded p-button-text" severity="secondary" title="View & Update TRF Form" tooltipOptions={{ position: 'top' }} onClick={(e) => editTrfDetailsForm(r)} />
                {/* <Button icon="pi pi-check" className="p-button-rounded p-button-text" severity="success" tooltip='Approve' onClick={() => apporvalForm(r)} tooltipOptions={{ position: 'top' }} /> */}
                {/* <Button icon="pi pi-times" className="p-button-rounded p-button-text" severity="danger" tooltip='Reject' onClick={() => rejectionForm(r)} tooltipOptions={{ position: 'top' }} /> */}
            </>}
            {o === 'feedback' && <>
                {/* <Button icon="pi pi-check" className="p-button-rounded p-button-text" tooltip='Update' onClick={() => updateAssesmentForm(r)} disabled={(r?.trainingDetails[0]?.trainingType === 'Instructor-Led' && r?.trainingDetails[0]?.is_assesment_completed && r?.trainingDetails[0]?.is_feedback_completed) || r?.trainingDetails[0]?.trainingType === 'Self-Paced' && !r?.trainingDetails[0]?.is_assesment_completed && r?.trainingDetails[0]?.is_feedback_completed ? true : false} /> */}

                <Button icon="pi pi-check" className="p-button-rounded p-button-text" tooltip='Update' onClick={() => updateAssesmentForm(r, 0)} disabled={r?.trainingDetails[0]?.trainingDetailStatus === 2 && ((r?.trainingDetails[0]?.trainingType === 'Instructor-Led' && !r?.trainingDetails[0]?.is_assessment && !r?.trainingDetails[0]?.is_feedback) || (r?.trainingDetails[0]?.trainingType === 'Self-Paced' && !r?.trainingDetails[0]?.is_assessment && !r?.trainingDetails[0]?.is_feedback)) ? false : true} />

                {/* <Button icon="pi pi-check" className="p-button-rounded p-button-text" tooltip='Update' onClick={() => updateAssesmentForm(r)} disabled={r?.trainingDetails[0]?.trainingDetailStatus === 2 && (r?.trainingDetails[0]?.trainingType === "Instructor-Led" && !r?.trainingDetails[0]?.is_assessment && !r?.trainingDetails[0]?.is_feedback) || (r?.trainingDetails[0]?.trainingType === "Self-Paced" && !r?.trainingDetails[0]?.is_assessment && !r?.trainingDetails[0]?.is_feedback) ? false : true} /> */}



                <Button icon="pi pi-check-circle" className="p-button-rounded p-button-text" severity="success" tooltip='Feedback' onClick={() => feedbackForm(r, 0)} tooltipOptions={{ position: 'top' }} disabled={(r?.trainingDetails[0]?.trainingType === 'Instructor-Led' && r?.trainingDetails[0]?.is_assesment_completed && r?.trainingDetails[0]?.is_feedback_completed && r?.trainingDetails[0]?.isManagerValidate && r?.trainingDetails[0]?.isManagerFeedback && !r?.trainingDetails[0]?.isTMFeedback) || (r?.trainingDetails[0]?.trainingType === 'Self-Paced' && r?.trainingDetails[0]?.is_feedback_completed && r?.trainingDetails[0]?.isManagerValidate && r?.trainingDetails[0]?.isManagerFeedback && !r?.trainingDetails[0]?.isTMFeedback) ? false : true} />
            </>}
        </>)
    }

    const apporvalForm = (r) => {
        setTrainingType(null);
        setActiveTRF(r);
        var Training_startDate = new Date(r?.trainingRequisitionDate);
        if (Training_startDate) setStartDate(Training_startDate);
        var Training_endDate = new Date(r?.endDateOfTraining);
        if (Training_endDate) setEndDate(Training_endDate);
        setTrainingType(r?.trainingType)
        setAppovalDialog(true);
    }

    const updateAssesmentForm = (r, type) => {
        setSelectedFeedbackType(type);
        setTrainingType(type === 1 ? selectedTrfForFedback[0].trainingDetails[0].trainingType : r?.trainingType);
        // setTrainingType(r?.trainingType);
        if (type === 0) {
            setActiveTRF(r);
            // setTrainingType(r?.trainingType);
            setNominatedParticipant(r?.nameOfNominatedParticipant);
            formik.setFieldValue('assesmentLink', r?.trainingDetails[0]?.assesment_link);
            formik.setFieldValue('feedbackLink', r?.trainingDetails[0]?.feedback_link);
            setTRFTrainingId(r?.trainingDetails[0]?.id.toString().padStart(7, '0'));
        }
        // if (type === 1) {
        //     setActiveTRF(r);
        //     setTrainingType(r?.trainingType);
        //     setNominatedParticipant(r?.nameOfNominatedParticipant);
        //     formik.setFieldValue('assesmentLink', r?.trainingDetails[0]?.assesment_link);
        //     formik.setFieldValue('feedbackLink', r?.trainingDetails[0]?.feedback_link);
        //     setTRFTrainingId(r?.trainingDetails[0]?.id.toString().padStart(7, '0'));
        // }

        setUpdateAssesmentDialog(true);
    }


    const isAttended = (rowData) => {
        const detail = rowData.trainingDetails[0]; // since it's an array
        return (
            detail?.trainingDetailStatus === 2 &&
            (
                // Case 1: Instructor-Led (no assessment, no feedback)
                (detail?.trainingType === 'Instructor-Led' &&
                    !detail?.is_assessment && !detail?.is_feedback) ||

                // Case 2: Self-Paced (no assessment, no feedback)
                (detail?.trainingType === 'Self-Paced' &&
                    !detail?.is_assessment && !detail?.is_feedback)
            )
        );
    };

    const updateAllAssesmentForm = () => {
        if (selectedTrfForFedback.length === 0) {
            toast.error("Please select atleast one attended record");
            return;
        }
        const allAttended = selectedTrfForFedback.every((row) => isAttended(row));
        if (!allAttended) {
            toast.error("only Attended Records can proceed.");
            return;
        }

        const firstCategory = selectedTrfForFedback[0].categoryOfTraining;
        const firstSkill = selectedTrfForFedback[0].targetSkill;
        const allSame = selectedTrfForFedback.every(item =>
            item.categoryOfTraining === firstCategory && item.targetSkill === firstSkill
        );
        if (!allSame) {
            toast.error("Error: categoryOfTraining or targetSkills do not match in all records.");
            return;
        }
        updateAssesmentForm(selectedTrfForFedback, 1);
    }

    const isAllFinalFeedback = (rowData) => {
        const detail = rowData.trainingDetails[0]; // since it's an array
        return (
            detail?.trainingDetailStatus === 2 &&
            (
                // Case 1: Instructor-Led (no assessment, no feedback)
                (detail?.trainingType === 'Instructor-Led' && detail?.is_assesment_completed && detail?.is_feedback_completed && detail?.isManagerValidate && detail?.isManagerFeedback && !detail?.isTMFeedback) ||

                // Case 2: Self-Paced (no assessment, no feedback)
                (detail?.trainingType === 'Self-Paced' && detail?.is_feedback_completed && detail?.isManagerValidate && detail?.isManagerFeedback && !detail?.isTMFeedback)
            )
        );
    };

    const updateAllFinalFeedbackForm = () => {
        if (selectedTrfForFedback.length === 0) {
            toast.error("Please select atleast one attended record");
            return;
        }
        const finalFeedbackAll = selectedTrfForFedback.every((row) => isAllFinalFeedback(row));
        if (!finalFeedbackAll) {
            toast.error("Final feedback can only be updated after the Manager has validated the training assesment and feedback.");
            return;
        }

        const firstCategory = selectedTrfForFedback[0].categoryOfTraining;
        const firstSkill = selectedTrfForFedback[0].targetSkill;
        const allSame = selectedTrfForFedback.every(item =>
            item.categoryOfTraining === firstCategory && item.targetSkill === firstSkill
        );
        if (!allSame) {
            toast.error("Error: categoryOfTraining or targetSkills do not match in all records.");
            return;
        }
        feedbackForm(selectedTrfForFedback, 1)
    }

    const onJobUpdateAssesmentForm = (r) => {
        setActiveTRF(r);
        setNominatedParticipant(r?.userName);
        setTrainingType(r?.trainingType);
        formik.setFieldValue('assesmentLink', r?.assesment_link);
        formik.setFieldValue('feedbackLink', r?.feedback_link);
        // setAssesmentLink(r?.assesment_link);
        // setFeedbackLink(r?.feedback_link);
        setTRFTrainingId(r?.id.toString().padStart(7, '0'));
        setUpdateAssesmentDialog(true);
    }

    // const rejectionForm = (r) => {
    //     setActiveTRF(r);
    //     var Training_startDate = new Date(r?.trainingRequisitionDate);
    //     if (Training_startDate) setStartDate(Training_startDate);
    //     var Training_endDate = new Date(r?.endDateOfTraining);
    //     if (Training_endDate) setEndDate(Training_endDate);
    //     setRejectDialog(true);
    // }

    const feedbackForm = (r, type) => {
        setSelectedFeedbackType(type);
        if (type === 0) {
            setActiveTRF(r);
            setEmpTrfDetailId(r?.trainingDetails[0]?.id);
            setEffectivenessSummary(r?.businessoutcomeDetails);
            setNominatedParticipant(r?.nameOfNominatedParticipant);
            setTrainingType(r?.trainingType)
            setTargetSkill(r?.targetSkills?.title);
            setOutcomeAchievedStatus(r?.trainingDetails[0]?.OutcomeAchieved ? 'YES' : 'NO');
            setManagerFeedbackComment(r?.trainingDetails[0]?.feedback);
        }
        setFeedbackDialog(true);
    }

    const onJobFeedbackForm = (r) => {
        setActiveTRF(r);
        setFeedbackDialog(true);
        setEmpTrfDetailId(r?.id);
        setEffectivenessSummary(r?.businessoutcomeDetails);
        setNominatedParticipant(r?.userName);
        setTrainingType(r?.trainingType)
        setTargetSkill(r?.targetSkills?.title);
        setOutcomeAchievedStatus(r?.OutcomeAchieved ? 'YES' : 'NO');
        setManagerFeedbackComment(r?.feedback);
    }

    const viewDialog = (r) => {
        setEditedTRFData(r)
        setIsVisible(true);
    };

    const viewTrfDetailDialog = (r) => {
        setEditedTRFData(r);
        setIsTrfDetailVisible(true);
    }

    const headerTemplate = (data) => {
        return (<div className='table-header'>
            <h2 className="image-text m-0 p-0">{data.nameOfRequester}</h2>
        </div>
        );
    }

    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    }


    const submitFinalFeedback = () => {
        let params = {
            // "id": empTrfDetailId,
            ids: selectedFeedbackType === 1 ? selectedTrfForFedback.map(item => item.trainingDetails[0].id) : [empTrfDetailId],
            "isTMFeedback": true,
            "finalReport": finalReport,
        }
        try {
            trainingApi.updateEmployeeTraining(params).then(
                (resp) => {
                    toast.success(resp.data.message);
                    setTimeout(() => {
                        setFeedbackDialog(false)
                        getHistory();
                        getOnJobTrfHistory();
                    }, 1000);
                },
                (err) => {
                    toast.error(err.response.data.error);
                }
            );
        } catch (error) {
            toast.error("Unable to update");
        }
    }

    const setTrainingFinalReport = (val) => {
        setFinalReport(val)
        // formik.setFieldValue('finalReport', val);
    }

    // const updateAssesmentStatus = (val) => {
    //     setEnableAssesmentStatus(val === "Yes" ? false : true);
    //     setAssesmentStatus(val);
    // }

    const renderfeedbackDialog = () => {
        return (<>
            <Dialog header="Training Effectiveness Report" visible={feedbackDialog} style={{ width: '700px' }} onHide={() => setFeedbackDialog(false)}>
                {/* <form onSubmit={formik.handleSubmit} autoComplete='off'> */}
                <div>
                    {selectedFeedbackType === 0 &&
                        <>
                            <div className="flex flex-wrap p-field font-bold block">
                                <div className="col-4">
                                    <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Employee Name</label>
                                    <div className="p-inputgroup flex-1">
                                        <span className="p-inputgroup-addon">
                                            <i className="pi pi-user"></i>
                                        </span>{" "}
                                        <InputText id="nominatedParticipant" disabled placeholder="Employee name" className="w-full" value={nominatedParticipant} />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Training Type</label>
                                    <div className="p-inputgroup flex-1">
                                        <InputText id="text" disabled placeholder="Training" className="w-full" value={trainingType} />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Target Skill</label>
                                    <div className="p-inputgroup flex-1">
                                        <InputText id="text" disabled placeholder="Skills" className="w-full" value={targetSkill} />
                                    </div>
                                </div>
                            </div>

                            <div className="grid">
                                <div className="col-4">
                                    <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Outcome Achived</label>
                                    <div className="p-inputgroup flex-1">
                                        {outcomeAchievedStatus}
                                    </div>
                                </div>
                                <div className="col-4">
                                    <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Manager Training Feedback</label>
                                    <div className="p-inputgroup flex-1">
                                        {managerFeedbackComment}
                                    </div>
                                </div>
                                {/* <div className="col-4">
                                <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Rating By Manager</label>
                                <div className="p-inputgroup flex-1">
                                    <InputText id="text" disabled placeholder="Skills" className="w-full" value={skillRatingByManager} />
                                </div>
                            </div> */}
                            </div>
                        </>
                    }
                    <div className='grid'>
                        {selectedFeedbackType === 0 &&
                            <div className="col-12">
                                <label htmlFor="comments" className="font-bold block mb-2 training-heading">
                                    Training Effectiveness Summary
                                </label>
                                <div className="mp-panel">
                                    {effectivenessSummary.map((item, index) => (
                                        <div className='col mr-2 bordered mt-1'>{item.title}</div>
                                    ))}
                                </div>
                            </div>
                        }
                        <div className="col-12">
                            <label htmlFor="comments" className="font-bold block mb-2 training-heading">
                                Final Report
                            </label>
                            <div className="">
                                <Editor name="finalReport" value={finalReport} onTextChange={(e) => setTrainingFinalReport(e.htmlValue)} style={{ height: '200px' }} />
                                {/* {getFormErrorMessage('finalReport')} */}
                            </div>
                        </div>
                    </div>
                </div>

                <hr />
                <div className='' style={{ textAlign: 'right' }}>
                    <Button label='Submit' icon='pi pi-save' severity='primary' className='mr-1' onClick={submitFinalFeedback} />
                    <Button label='Cancel' type='button' icon='pi pi-times' severity='secondary' onClick={() => setFeedbackDialog(false)} />
                </div>
                {/* </form> */}
            </Dialog>
        </>)
    }

    const assesmentDialog = () => {
        return (<>
            <Dialog header="Update TRF Assesment" visible={updateAssesmentDialog} style={{ width: '700px' }} onHide={() => setUpdateAssesmentDialog(false)}>
                <hr />
                <form onSubmit={formik.handleSubmit} autoComplete='off'>
                    <div>
                        {selectedFeedbackType === 0 &&
                            <div className="flex flex-wrap p-field font-bold block">
                                <div className="col-6">
                                    <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Employee Name</label>
                                    <div className="p-inputgroup flex-1">
                                        <span className="p-inputgroup-addon">
                                            <i className="pi pi-user"></i>
                                        </span>{" "}
                                        <InputText id="nominatedParticipant" disabled placeholder="Employee name" className="w-full" value={nominatedParticipant} />
                                    </div>
                                </div>

                                <div className="col-6">
                                    <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Training ID</label>
                                    <div className="p-inputgroup flex-1">
                                        <span className="p-inputgroup-addon">
                                            <i className="pi pi-eject"></i>
                                        </span>{" "}
                                        <InputText id="nominatedParticipant" disabled placeholder="Training ID" className="w-full" value={tRFTrainingId} />
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="flex flex-wrap p-field font-bold block">
                            <div className="col-6">
                                <label htmlFor="assesmentLink" disabled className="font-bold block mb-2 training-heading">Assesment Link</label>
                                <div className="p-inputgroup flex-1">
                                    <InputText name="assesmentLink" placeholder="Assesment Link" className="w-full" value={formik.values.assesmentLink} onChange={formik.handleChange} disabled={trainingType === 'Instructor-Led' ? false : true} />
                                </div>
                                {getFormErrorMessage('assesmentLink')}
                            </div>
                            <div className="col-6">
                                <label htmlFor="feedbackLink" className="font-bold block mb-2 training-heading ">Feedback Link</label>
                                <InputText name="feedbackLink" placeholder="Feedback Link" className="w-full" value={formik.values.feedbackLink} onChange={formik.handleChange} />
                                {getFormErrorMessage('feedbackLink')}
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className='' style={{ textAlign: 'right' }}>
                        <Button label='Update' icon='pi pi-check' severity='primary' className='mr-1' />
                        <Button label='Cancel' type='button' icon='pi pi-times' severity='secondary' onClick={() => setUpdateAssesmentDialog(false)} />
                    </div>
                </form>
            </Dialog>
        </>)
    }

    const approvalDialog__ = () => {
        return (<>
            <Dialog header="TRF Approvals" visible={appovalDialog} style={{ width: '700px' }} onHide={() => { setAppovalDialog(false); setIsValid(false); setFeedback(''); }}>
                <div>
                    {/* <div className="flex flex-wrap p-field font-bold block">
                        <div className="col-6">
                            <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Employee Name</label>
                            <div className="p-inputgroup flex-1">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-user"></i>
                                </span>{" "}
                                <InputText id="nominatedParticipant" disabled placeholder="Employee name" className="w-full" value={activeTRF?.nameOfNominatedParticipant} />
                            </div>
                        </div>
                        <div className="col-6">
                            <label htmlFor="trainingType" className="font-bold block mb-2 training-heading ">Training Type</label>
                            <Dropdown id="trainingType" disabled className="w-full" value={trainingType} options={typeOfTraining} onChange={(e) => setTrainingType(e.value)} placeholder="Select Training Type" />
                        </div>
                    </div> */}

                    <div className="flex flex-wrap p-field font-bold block">
                        {/* <div className="col-6">
                            <label htmlFor="startDate" className="font-bold block mb-2 training-heading mt-2"> Start Date</label>
                            <Calendar disabled id="startDate" value={startDate} onChange={(e) => setStartDate(e.value)} showIcon className="w-full requisition-date" placeholder="Enter Start Date" />
                        </div>
                        <div className="col-6">
                            <label htmlFor="endDate" className="font-bold block mb-2 training-heading mt-2" >End Date</label>
                            <Calendar disabled id="endDate" showIcon className="w-full requisition-date" placeholder="Enter End Date" value={endDate} onChange={(e) => setEndDate(e.value)} />
                        </div> */}
                        <div className="col-12">
                            <label htmlFor="feedback" className="font-bold block mb-2 training-heading mt-2" >Notes</label>
                            {/* <InputText name="comments" placeholder="Provide feedback" required style={{ background: "white" }} className="w-full" /> */}
                            <Editor
                                headerTemplate={renderHeader}
                                style={{ height: '200px' }}
                                placeholder="Provide feedbacks"
                                id="feedback"
                                value={feedback}
                                onTextChange={(e) => { setFeedback(e.htmlValue ? e.htmlValue : ''); isCommentCheck(e.htmlValue, "Approved") }}
                            />
                        </div>
                        {!feedbackApprovalStatus && (<span style={{ color: 'red' }}>Approval Note is Required!</span>)}
                    </div>
                </div>

                <hr />
                <div className='' style={{ textAlign: 'right' }}>
                    <Button label='Approve' icon='pi pi-check' severity='primary' className='mr-1' onClick={() => handleTrfApproval("Approved")} />
                    <Button label='Cancel' icon='pi pi-times' severity='secondary' onClick={() => { setAppovalDialog(false); setIsValid(false); setFeedback(''); }} />
                </div>
            </Dialog>
        </>)
    }

    const approvalDialog = () => {
        return (<>
            <Dialog header="TRF Approvals" visible={appovalDialog} className='full_dialog' onHide={() => { setAppovalDialog(false); setIsValid(false); setFeedback(''); }}>
                <EditEmpTrfForm reload={reload} userTrfDetail={selectedTrfForApproval[0]} type={1} userDetails={selectedTrfForApproval} viewType={true} />
            </Dialog>
        </>)
    }

    const rejectionDialog = () => {
        return (<>
            <Dialog header="TRF Rejection" visible={rejectDialog} style={{ width: '700px' }} onHide={() => { setRejectDialog(false); setIsValid(false); setFeedback(''); }}>
                <div>
                    <h2>{activeTRF?.nameOfNominatedParticipant}</h2>
                    <div className="flex flex-wrap p-field font-bold block">
                        <div className="col-12">
                            <label htmlFor="feedback" className="font-bold block mb-2 training-heading mt-2" >Rejection Note :</label>
                            {/* <InputText name="comments" placeholder="Provide feedback" required style={{ background: "white" }} className="w-full" /> */}
                            <Editor headerTemplate={renderHeader} style={{ height: '200px' }} placeholder="Rejection Note" value={feedback} onTextChange={(e) => { setFeedback(e.htmlValue ? e.htmlValue : ''); isCommentCheck(e.htmlValue, "Rejection") }} />
                        </div>
                        {!feedbackRejectedStatus && (<span style={{ color: 'red' }}>Rejection Note is Required!</span>)}
                    </div>
                </div>

                <hr />
                <div className='' style={{ textAlign: 'right' }}>
                    {/* <Button label='Reject' icon='pi pi-check' severity='primary' className='mr-1' onClick={() => handleSubmit("Rejection")} /> */}
                    <Button label='Reject' icon='pi pi-check' severity='primary' className='mr-1' onClick={() => handleTrfApproval("Rejection")} />
                    <Button label='Cancel' icon='pi pi-times' severity='secondary' onClick={() => { setRejectDialog(false); setIsValid(false); setFeedback(''); }} />
                </div>
            </Dialog>
        </>)
    }


    const formik = useFormik({
        initialValues: {
            assesmentLink: '',
            feedbackLink: ''
        },
        validate: (data) => {
            let errors = {};
            if (trainingType === 'Instructor-Led') {
                if (!data.assesmentLink) errors.assesmentLink = 'Assesment Link is required.';
            }
            if (!data.feedbackLink) errors.feedbackLink = 'Feedback Link is required.';
            return errors;
        },
        onSubmit: (data) => {
            let params = {
                // id: activeTRF?.trainingDetails[0]?.id,
                ids: selectedFeedbackType === 1 ? selectedTrfForFedback.map(item => item.trainingDetails[0].id) : [tRFTrainingId],
                // id: tRFTrainingId,
                assesment_link: data.assesmentLink,
                is_assessment: data.assesmentLink ? true : false,
                feedback_link: data.feedbackLink,
                is_feedback: data.feedbackLink ? true : false,
            }
            try {
                trainingApi.updateEmployeeTraining(params).then(
                    (resp) => {
                        setSelectedFeedbackType(0);
                        setSelectedTrfForFedback([]);
                        toast.success(resp.data.message);
                        setUpdateAssesmentDialog(false);
                        setTimeout(() => {
                            getHistory()
                        }, 1000);
                    },
                    (err) => {
                        toast.error(err.response.data.error);
                    }
                );
            } catch (error) {
                toast.error("Unable to update");
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    // const updateAssesment___ = () => {
    //     let params = {
    //         // id: activeTRF?.trainingDetails[0]?.id,
    //         id: tRFTrainingId,
    //         assesment_link: assesmentLink,
    //         is_assessment: assesmentLink ? true : false,
    //         feedback_link: feedbackLink,
    //         is_feedback: feedbackLink ? true : false,
    //     }
    //     try {
    //         trainingApi.updateEmployeeTraining(params).then(
    //             (resp) => {
    //                 toast.success(resp.data.message);
    //                 setUpdateAssesmentDialog(false);
    //                 setTimeout(() => {
    //                     getHistory()
    //                 }, 1000);
    //             },
    //             (err) => {
    //                 toast.error(err.response.data.error);
    //             }
    //         );
    //     } catch (error) {
    //         toast.error("Unable to update");
    //     }
    // }

    const isCommentCheck = (val, type) => {
        if (type === "Approved") {
            if (val) {
                setFeedbackApprovalStatus(true);
                setFeedbackRejectedStatus(true);
                setIsValid(true);
            } else {
                setFeedbackApprovalStatus(false);
                setFeedbackRejectedStatus(false);
                setIsValid(false);
            }
        }

        if (type === "Rejection") {
            if (val) {
                setFeedbackRejectedStatus(true);
                setIsValid(true);
            } else {
                setFeedbackRejectedStatus(false);
                setIsValid(false);
            }
        }

    }

    const handleSubmit = (status) => {
        if (status === "Feedback") {
            setIsValid(true);
            var dataObj = [
                {
                    // training: activeTRF?.id,
                    training: tRFTrainingId,
                    summary: Util.removeHtmlTags(summary),
                    finalReport: Util.removeHtmlTags(finalReport)
                },
            ];
        } else {
            if (status === "Approved" && feedback == '') {
                setFeedbackApprovalStatus(false);
                setIsValid(false);
            } else {
                setFeedbackApprovalStatus(true);
                setIsValid(true);
            }

            if (status === "Rejection" && feedback == '') {
                setFeedbackRejectedStatus(false);
                setIsValid(false);
            } else {
                setFeedbackRejectedStatus(true);
                setIsValid(true);
            }
            var dataObj = [
                {
                    reason: status === "Approved" ? "approve" : "reject",
                    status: status === "Approved" ? 5 : 6,
                    comments: Util.removeHtmlTags(feedback),
                    trainingType: trainingType,
                    endDateOfTraining: endDate,
                    trainingRequisitionDate: startDate,
                    assesment_link: assesmentLink,
                    is_assessment: assesmentLink ? true : false,
                    feedback_link: feedbackLink,
                    is_feedback: feedbackLink ? true : false,
                    training: activeTRF?.id,
                    targetSkillName: activeTRF?.targetSkills?.title,
                },
            ];
        }
        try {
            if (isValid) {
                trainingApi.updateApproveRejectTrainingForm(dataObj).then(
                    (resp) => {
                        toast.success(resp?.data?.message);
                        setAppovalDialog(false);
                        setRejectDialog(false);
                        setFeedbackDialog(false);
                        setTimeout(() => {
                            getHistory();
                            getOnJobTrfHistory();
                        }, 1000);
                    },
                    (err) => {
                        toast.error(err.response.data.error);
                    }
                );
            }
        } catch (error) {
            toast.error("Unable to update");
        }
    };

    const viewEmpTrainingDetail = (rowData) => {
        console.log(rowData, "viewEmpTrainingDetailviewEmpTrainingDetail")
        setActiveRecord(rowData?.trainingDetails[0]);
        setEmpDetailDialog(true);
    }

    const refreshTeamTrainingData = () => {
        setEmpDetailDialog(false);
        getHistory();
    }

    // const trainingManagerStatusTemp_1 = (rowData) => {
    //     if (rowData?.trainingDetailStatus === 1) {
    //         return <span>In Progress</span>;
    //     } else if (rowData?.trainingDetailStatus === 2 && !rowData?.is_assessment && !rowData?.is_feedback) {
    //         return <span>Attended</span>;
    //     } else if (rowData?.trainingDetailStatus === 2 && rowData?.is_assessment && rowData?.is_feedback && !rowData?.is_assesment_completed && !rowData?.is_feedback_completed) {
    //         return <span>Assesment Pending</span>;
    //     } else if (rowData?.trainingDetailStatus === 2 && rowData?.is_assessment && rowData?.is_feedback && rowData?.is_assesment_completed && !rowData?.is_feedback_completed) {
    //         return <span>Feedback Pending</span>;
    //     } else if (rowData?.trainingDetailStatus === 2 && rowData?.is_assessment && rowData?.is_feedback && rowData?.is_assesment_completed && rowData?.is_feedback_completed) {
    //         return <span>Completed</span>;
    //     } else {
    //         return <span>TODO</span>;
    //     }
    // }

    const trainingManagerStatusTemp = (rowData) => {
        if (rowData?.trainingDetailStatus === 1) {
            return <span>In Progress</span>;
        }
        if (rowData?.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            (rowData?.trainingType === 'Instructor-Led' &&
                !rowData?.is_assessment && !rowData?.is_feedback
            ) ||

            // Case 2: Non-Instructor-Led with specific criteria
            (rowData?.trainingType === 'Self-Paced' &&
                !rowData?.is_assessment && !rowData?.is_feedback
            )
        )
        ) {
            return <span>Attended</span>;
        }
        if (rowData?.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            // (rowData?.trainingType === 'Instructor-Led' &&
            //     rowData?.is_assessment &&
            //     rowData?.is_feedback &&
            //     !rowData?.is_assesment_completed &&
            //     !rowData?.is_feedback_completed
            // )
            (rowData?.trainingType === 'Instructor-Led' &&
                rowData?.is_assessment &&
                rowData?.is_feedback &&
                !rowData?.is_assesment_completed
            )
        )
        ) {
            return <span>Assessment Pending</span>;
        }
        if (rowData?.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            (rowData?.trainingType === 'Instructor-Led' &&
                rowData?.is_assessment &&
                rowData?.is_feedback &&
                rowData?.is_assesment_completed &&
                !rowData?.is_feedback_completed
            ) ||
            // Case 2: Non-Instructor-Led with specific criteria
            (rowData?.trainingType === 'Self-Paced' &&
                !rowData?.is_assessment &&
                rowData?.is_feedback &&
                !rowData?.is_assesment_completed &&
                !rowData?.is_feedback_completed
            )
        )
        ) {
            return <span>Feedback Pending</span>;
        }
        if (rowData?.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            (rowData?.trainingType === 'Instructor-Led' &&
                rowData?.is_assessment &&
                rowData?.is_feedback &&
                rowData?.is_assesment_completed &&
                rowData?.is_feedback_completed
            ) ||
            // Case 2: Non-Instructor-Led with specific criteria
            (rowData?.trainingType === 'Self-Paced' &&
                !rowData?.is_assessment &&
                rowData?.is_feedback &&
                // !rowData?.is_assesment_completed &&
                rowData?.is_feedback_completed
            )
        )
        ) {
            return <span>Completed</span>;
        }
        // Fallback
        return <span>TODO</span>;
    };

    // const trainingStatusTemp_1 = (rowData) => {
    //     if (rowData.trainingDetailStatus === 1) {
    //         return <span>In Progress</span>;
    //     } else if (rowData.trainingDetailStatus === 2 && !rowData.is_assessment && !rowData.is_feedback) {
    //         return <span>Attended</span>;
    //     } else if (rowData.trainingDetailStatus === 2 && rowData.is_assessment && rowData.is_feedback && !rowData.is_assesment_completed && !rowData.is_feedback_completed) {
    //         return <span>Assesment Pending</span>;
    //     } else if (rowData.trainingDetailStatus === 2 && rowData.is_assessment && rowData.is_feedback && rowData.is_assesment_completed && !rowData.is_feedback_completed) {
    //         return <span>Feedback Pending</span>;
    //     } else if (rowData.trainingDetailStatus === 2 && rowData.is_assessment && rowData.is_feedback && rowData.is_assesment_completed && rowData.is_feedback_completed) {
    //         return <span>Completed</span>;
    //     } else {
    //         return <span>TODO</span>;
    //     }
    // }

    const trainingStatusTemp = (rowData) => {
        if (rowData.trainingDetailStatus === 1) {
            return <span>In Progress</span>;
        }
        if (rowData.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            (rowData.trainingType === 'Instructor-Led' &&
                !rowData.is_assessment && !rowData.is_feedback
            ) ||

            // Case 2: Non-Instructor-Led with specific criteria
            (rowData.trainingType === 'Self-Paced' &&
                !rowData.is_assessment && !rowData.is_feedback
            )
        )
        ) {
            return <span>Attended</span>;
        }
        if (rowData.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            (rowData.trainingType === 'Instructor-Led' &&
                rowData.is_assessment &&
                rowData.is_feedback &&
                !rowData.is_assesment_completed &&
                !rowData.is_feedback_completed
            )
        )
        ) {
            return <span>Assessment Pending</span>;
        }
        if (rowData.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            (rowData.trainingType === 'Instructor-Led' &&
                rowData.is_assessment &&
                rowData.is_feedback &&
                rowData.is_assesment_completed &&
                !rowData.is_feedback_completed
            ) ||
            // Case 2: Non-Instructor-Led with specific criteria
            (rowData.trainingType === 'Self-Paced' &&
                !rowData.is_assessment &&
                rowData.is_feedback &&
                !rowData.is_assesment_completed &&
                !rowData.is_feedback_completed
            )
        )
        ) {
            return <span>Feedback Pending</span>;
        }
        if (rowData.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            (rowData.trainingType === 'Instructor-Led' &&
                rowData.is_assessment &&
                rowData.is_feedback &&
                rowData.is_assesment_completed &&
                rowData.is_feedback_completed
            ) ||
            // Case 2: Non-Instructor-Led with specific criteria
            (rowData.trainingType === 'Self-Paced' &&
                !rowData.is_assessment &&
                rowData.is_feedback &&
                !rowData.is_assesment_completed &&
                rowData.is_feedback_completed
            )
        )
        ) {
            return <span>Completed</span>;
        }
        // Fallback
        return <span>TODO</span>;
    };

    const selectMultiTrf = (e) => {
        setSelectedTrfForApproval(e.value);
    };

    const selectMultiTrfFeedback = (e) => {
        setSelectedTrfForFedback(e.value);
    };

    const approveRejectSelectedTrf = (type) => {
        if (selectedTrfForApproval.length === 0) {
            toast.error("Please select atleast one TRF");
            return;
        }
        //Matched Same Records for Approvals
        const firstCategory = selectedTrfForApproval[0].categoryOfTraining;
        const firstSkill = selectedTrfForApproval[0].targetSkill;

        const allSame = selectedTrfForApproval.every(item =>
            item.categoryOfTraining === firstCategory && item.targetSkill === firstSkill
        );
        if (!allSame) {
            toast.error("Error: categoryOfTraining or targetSkills do not match in all records.");
            return;
        }

        if (type === '1') {
            setAppovalDialog(true);
        }
        if (type === '2') {
            setRejectDialog(true);
        }
    }

    const handleTrfApproval = (status) => {
        if (status === "Approved" && feedback == '') {
            setFeedbackApprovalStatus(false);
            setIsValid(false);
        } else {
            setFeedbackApprovalStatus(true);
            setIsValid(true);
        }
        if (status === "Rejection" && feedback == '') {
            setFeedbackRejectedStatus(false);
            setIsValid(false);
        } else {
            setFeedbackRejectedStatus(true);
            setIsValid(true);
        }
        var dataObj = {
            trainingId: selectedTrfForApproval.map(item => item.id),
            comments: Util.removeHtmlTags(feedback),
            isApproved: status === "Approved" ? true : false,
            // status: status === "Approved" ? 5 : 6,
        };
        try {
            if (isValid) {
                trainingApi.updateApproveRejectMultiTrainingForm(dataObj).then(
                    (resp) => {
                        toast.success(resp?.data?.messages[0]);
                        setAppovalDialog(false);
                        setRejectDialog(false);
                        setFeedbackDialog(false);
                        setTimeout(() => {
                            getHistory();
                            getOnJobTrfHistory();
                        }, 1000);
                    },
                    (err) => {
                        toast.error(err.response.data.error);
                    }
                );
            }
        } catch (error) {
            toast.error("Unable to update");
        }
    };

    const filterUserTraining = () => {
        if (!filteredTrainingCategory || !filterSkill?.title) {
            // Show some validation message
            alert("Please select both Training Category and Skill to search.");
            return;
        }
        let param = {
            skill: filterSkill?.title || '',
            category: filteredTrainingCategory,
        };

        trainingApi.filterTrfBySkill(param).then(resp => {
            const data = resp.data?.data;
            setHistory(sortByRequesterName(data));

            const pendings = data.filter(x => x.status === 4 || x.status === 2);
            setApprovals(sortByRequesterName(pendings));

            const feedbacks = data.filter(x => x.status === 5);
            setFeedbacks(sortByRequesterName(feedbacks));

            const activeFeedbackBadge = feedbacks.filter((el) => {
                return !el?.trainingDetails[0]?.isTMFeedback;
            });
            setFeedbackBadgeCount(activeFeedbackBadge.length);

        }).catch(e => {
        });
    }

    const clearFilterdata = () => {
        setFilteredTrainingCategory(null);
        setFilterSkill(null);
        // getApprovals();
    }

    return (
        <div className='ess-page'>
            <div className="formgrid grid mt-2">
                <div className="field col-12 md:col-7">
                    <div className='mb-2'>
                        <Button label="Approvals" className={tab === "Approvals" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setTab('Approvals')} badge={approvals?.length} badgeClassName="p-badge-danger" />
                        <Button label="Training Feedback" className={tab === "Feedback" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setTab('Feedback')} badge={feedbackBadgeCount} badgeClassName="p-badge-warning" />
                        <Button label="TRF History" className={tab === "History" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setTab('History')} badge={history?.length} badgeClassName="p-badge-warning" />
                        {/* <Button label="On Job Training History" className={tab === "onJobHistory" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setTab('onJobHistory')} badge={onJobBadgeCount} badgeClassName="p-badge-warning" /> */}

                        {/* <Button label="Approved" className={tab === "Approved" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setTab('Approved')} badge={approved.length} badgeClassName="p-badge-danger" />
                <Button label="Rejected" className={tab === "Rejected" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setTab('Rejected')} badge={rejected.length} badgeClassName="p-badge-danger" /> */}
                    </div>
                </div>
                {(tab === "Approvals" || tab === "Feedback") && (
                    <div className="field col-12 md:col-5 mb-2">
                        <div className="formgrid grid training_head">
                            <div className="field col-4">
                                <Dropdown name="trainingCategory" value={filteredTrainingCategory} onChange={(e) => setFilteredTrainingCategory(e.value)} options={trainingCategory} optionLabel="title" optionValue="title" placeholder="Select a Category" className="w-full" />
                            </div>
                            <div className="field col-4">
                                <AutoComplete
                                    value={filterSkill}
                                    suggestions={filteredSkill}
                                    completeMethod={searchSkill}
                                    field="title"
                                    name="targetSkill"
                                    // multiple
                                    virtualScrollerOptions={{ itemSize: 38 }}
                                    onChange={(e) => setFilterSkill(e.value)}
                                    placeholder="Filter By Skill"
                                    aria-label="Skills"
                                    dropdownAriaLabel="Select Skills"
                                    className="w-full"
                                    style={{maxWidth: '100%'}}
                                />
                            </div>
                            <div className="field col-4">
                                <Button label="Filter" className="p-button-rounded mr-2 mb-2" type="button" onClick={filterUserTraining} />
                                {/* icon="pi pi-search" */}
                                <Button label="Clear" className="p-button-rounded mr-2 mb-2" type="button" onClick={clearFilterdata} />
                                {/* icon="pi pi-times" */}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className='ess-table bordered-wrapper'>
                {tab === 'Approvals' && <div>
                    <DataTable value={approvals} stripedRows responsiveLayout="scroll"
                        paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                        rowGroupMode="subheader" groupRowsBy="nameOfRequester" rowGroupHeaderTemplate={headerTemplate}
                        selection={selectedTrfForApproval}
                        onSelectionChange={(e) => selectMultiTrf(e)}
                    >
                        {/* <Column field="nameOfRequester" header="Requestor" headerStyle={{ width: '100px' }}  ></Column> */}
                        <Column selectionMode="multiple" headerStyle={{ width: "8rem" }}></Column>
                        <Column field="nameOfNominatedParticipant" header="Participent" headerStyle={{ width: '200px' }}  ></Column>
                        <Column field="project" header="Project" headerStyle={{ width: '200px' }} body={(r) => <span className='capitalize'>{r?.projectName}</span>}  ></Column>
                        <Column field="categoryOfTraining" header="Category" headerStyle={{ width: '120px' }} body={(r) => <span className='capitalize'>{r?.categoryOfTrainings?.title}</span>}></Column>
                        <Column field="targetSkills" header="Target Skill" body={(r) => <span className='capitalize'>{r?.targetSkills?.title}</span>}></Column>
                        {/* <Column field="currentTechnology" header="Techonology"></Column> */}
                        {/* <Column field="trainingRequisitionDate" header="Requ. Date" headerStyle={{ width: '100px' }} body={(r) => (utitService.dateWithMonthConverter(r.trainingRequisitionDate))} ></Column> */}
                        <Column field="startDateOfTraining" header="Exp. Start Date" headerStyle={{ width: '110px' }} body={(r) => (utitService.dateWithMonthConverter(r.startDateOfTraining))}></Column>
                        <Column field="endDateOfTraining" header="Exp. End Date" headerStyle={{ width: '110px' }} body={(r) => (utitService.dateWithMonthConverter(r.endDateOfTraining))}></Column>
                        <Column header="Actions" style={{ width: '120px', textAlign: 'center' }} body={(r) => actionBody(r, 'approvals')} />
                    </DataTable>
                    <div className="formgrid grid mt-2">
                        <div className="field col-12">
                            <Button label="Approve All" icon="pi pi-check" className="p-button-rounded" onClick={() => approveRejectSelectedTrf('1')} />
                            <Button label="Reject All" icon="pi pi-times" className="p-button-rounded ml-2" onClick={() => approveRejectSelectedTrf('2')} />
                        </div>
                    </div>
                </div>}
                {tab === 'Feedback' && <div>
                    <DataTable value={feedbacks} stripedRows responsiveLayout="scroll"
                        paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                        rowGroupMode="subheader" groupRowsBy="nameOfRequester" rowGroupHeaderTemplate={headerTemplate}
                        selection={selectedTrfForFedback}
                        onSelectionChange={(e) => selectMultiTrfFeedback(e)}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: "8rem" }}></Column>
                        <Column field="" header="Training ID" body={(rowData) => (<span title="View Training Detail" style={{ cursor: 'pointer', color: 'blue', }} onClick={() => viewEmpTrainingDetail(rowData)}>{rowData?.trainingDetails[0]?.id.toString().padStart(7, '0')}</span>)}></Column>
                        <Column field="nameOfNominatedParticipant" header="Participent"></Column>
                        <Column field="project" header="Project" body={(r) => <span className='capitalize'>{r?.projectName}</span>} ></Column>
                        <Column field="categoryOfTraining" header="Category" body={(r) => <span className='capitalize'>{r?.categoryOfTrainings?.title}</span>}></Column>
                        <Column field="targetSkills" header="Target Skill" body={(r) => <span className='capitalize'>{r?.targetSkills?.title}</span>}></Column>
                        {/* <Column field="currentTechnology" header="Techonology"></Column> */}
                        {/* <Column field="trainingRequisitionDate" header="Requ. Date" body={(r) => (utitService.dateWithMonthConverter(r.trainingRequisitionDate))} ></Column> */}
                        <Column field="startDateOfTraining" header="Exp. Start Date" body={(r) => (utitService.dateWithMonthConverter(r.startDateOfTraining))}></Column>
                        <Column field="endDateOfTraining" header="Exp. End Date" body={(r) => (utitService.dateWithMonthConverter(r.endDateOfTraining))}></Column>
                        {/* <Column field="" header="Training Status" body={(r) => (utitService.getUserTrainingStatus(r?.trainingDetails[0]?.trainingDetailStatus))}></Column> */}
                        <Column field="" header="Training Status" body={(r) => (trainingManagerStatusTemp(r?.trainingDetails[0]))}></Column>
                        <Column header="Actions" body={(r) => actionBody(r, 'feedback')} />
                    </DataTable>
                    <div className="formgrid grid mt-2">
                        <div className="field col-12">
                            <Button label="Update All Assesment/Feedback" icon="pi pi-check" className="p-button-rounded" onClick={() => updateAllAssesmentForm()} disabled={selectedTrfForFedback?.length > 0 ? false : true} />
                            <Button label="Update Final Feedback" icon="pi pi-check" className="p-button-rounded ml-2" onClick={() => updateAllFinalFeedbackForm()} disabled={selectedTrfForFedback?.length > 0 ? false : true} />
                        </div>
                    </div>
                </div>}
                {tab === 'History' && <div>
                    <DataTable value={history} stripedRows responsiveLayout="scroll"
                        paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                        rowGroupMode="subheader" groupRowsBy="nameOfRequester" rowGroupHeaderTemplate={headerTemplate}
                    >
                        <Column field="nameOfNominatedParticipant" header="Participent" headerStyle={{ width: '200px' }}  ></Column>
                        <Column field="categoryOfTraining" header="Category" headerStyle={{ width: '120px' }} body={(r) => <span className='capitalize'>{r?.categoryOfTrainings?.title}</span>}></Column>
                        <Column field="targetSkills" header="Target Skill" body={(r) => <span className='capitalize'>{r?.targetSkills?.title}</span>}></Column>
                        {/* <Column field="currentTechnology" header="Techonology"></Column> */}
                        {/* <Column field="trainingRequisitionDate" header="Requ. Date" body={(r) => (utitService.dateWithMonthConverter(r.trainingRequisitionDate))} ></Column> */}
                        <Column field="trainingCost" header="Training Cost"></Column>
                        <Column field="startDateOfTraining" header="Exp. Start Date" body={(r) => (utitService.dateWithMonthConverter(r.startDateOfTraining))}></Column>
                        <Column field="endDateOfTraining" header="Exp. End Date" body={(r) => (utitService.dateWithMonthConverter(r.endDateOfTraining))}></Column>
                        <Column field="status" header="Status" headerStyle={{ width: '150px' }} body={(rowData) => (utitService.getTrainingStatus(rowData.status))} ></Column>
                        <Column header="Actions" style={{ width: '120px', textAlign: 'center' }} body={(r) => actionBody(r, 'history')} />
                    </DataTable>
                </div>}
                {/* {tab === 'onJobHistory' && <div>
                    <DataTable value={onJobTrf} stripedRows responsiveLayout="scroll"
                        paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                        rowGroupMode="subheader" groupRowsBy="nameOfRequester" rowGroupHeaderTemplate={headerTemplate}
                    >
                        <Column field="userName" header="Participent" headerStyle={{ width: '200px' }}  ></Column>
                        <Column field="categoryOfTraining" header="Category" headerStyle={{ width: '120px' }} body={(r) => <span className='capitalize'>{r?.categoryOfTrainings?.title}</span>}></Column>
                        <Column field="targetSkills" header="Target Skill" body={(r) => <span className='capitalize'>{r?.targetSkills?.title}</span>}></Column>
                        <Column field="NoOfHours" header="No Of Hours"></Column>
                        <Column field="endDateOfTraining" header="Exp. End Date" headerStyle={{ width: '110px' }} body={(r) => (utitService.dateWithMonthConverter(r.endDate))}></Column>
                        <Column field="status" header="Status" headerStyle={{ width: '100px' }} body={trainingStatusTemp} ></Column>
                        <Column header="Actions" style={{ width: '120px', textAlign: 'center' }} body={(r) => actionTrfDetailsBody(r, 'history')} />
                    </DataTable>
                </div>} */}
            </div>
            <Dialog className='custom_popup' header="View TRF Details" visible={isVisible} onHide={() => setIsVisible(false)} style={{ width: '80vw' }}>
                <TrfDetailsView parent={true} setNewTrf={setNewTrf} reload={getHistory} clickedRowData={editedTRFData} type="normal" />
                {/* <Trf parent={true} setNewTrf={setNewTrf} reload={getHistory} isView={true} editedTRFData={editedTRFData} /> */}
            </Dialog>

            <Dialog header="View Employee Training Detail" visible={isTrfDetailVisible} onHide={() => setIsTrfDetailVisible(false)} style={{ width: '80vw' }}>
                <EmpTrfDetailsView parent={true} setNewTrf={setNewTrf} reload={getHistory} clickedRowData={editedTRFData} />
            </Dialog>
            {approvalDialog()}
            {assesmentDialog()}
            {rejectionDialog()}
            {renderfeedbackDialog()}
            {editTrfDetailsDialog()}

            <Dialog header="View Training Status" visible={empDetailDialog} onHide={() => refreshTeamTrainingData()} style={{ width: '80vw' }}>
                <TeamTrainingUserDetailsView clickedRowData={activeRecord} />
            </Dialog>
        </div>
    )
}

export default AdminTrfListing